import { useEffect, useRef, useState } from "react";
import { keycloak } from "../../../lib/keycloak";
import { colors } from "../../color";
import { LogoutIcon } from "../../icons/logoutIcon";
import Avatar from "../../molecoles/avatar";

export function HeaderComponent() {
    const menuRef = useRef<HTMLTableCellElement>(null);

    const [showMenu, setShowMenu] = useState(false)
    const [isHover, setIsHover] = useState(false)

    const toggleMenu = () => {
        setShowMenu(!showMenu);
    };

    const closeMenu = () => {
        setShowMenu(false);
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
            closeMenu();
        }
    };

    useEffect(() => {
        if (showMenu) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showMenu]);

    return (
        <div className="flex flex-row gap-[16px] items-center">
            <div className="cursor-pointer relative flex items-center gap-1.5"
                onClick={e => { toggleMenu() }}
                ref={menuRef}>
                <span className="text-text-sm font-semibold text-pas-700">
                    {'Admin'}
                </span>
                <div>
                    <Avatar type="single" size="md" shape="circle" imageUrl={""} altTextInitials={"A"} />
                    {
                        showMenu &&
                        <div
                            onClick={e => {
                                e.preventDefault();
                                e.stopPropagation();
                                keycloak.logout();
                            }}
                            onMouseEnter={() => setIsHover(true)}
                            onMouseLeave={() => setIsHover(false)}
                            style={{
                                backgroundColor: isHover ? colors.pas[200] : colors.white
                            }}
                            className={"absolute right-2 shadow-sm rounded-xl p-3 gap-2 flex items-center w-[200px]"}
                        >
                            <LogoutIcon color={!isHover ? colors.pas[600] : colors.pas[500]} size={20} />
                            <span
                                onMouseEnter={() => setIsHover(true)}
                                onMouseLeave={() => setIsHover(false)}
                                style={{
                                    color: isHover ? colors.pas[500] : colors.pas[600]
                                }}
                                className={"text-text-md font-semibold"}
                            >
                                Esci
                            </span>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}